module.exports = __webpack_public_path__ + "img/plus.6a891c2c.png";